import React from 'react';
import { css } from '@emotion/css';
import ScreenPreviewComponent from '../ScreenPreviewComponent';
import AlexaRectangleWrapper from './AlexaRectangleWrapper';

const screenStyle = css`
    video {
        width: 1920px;
        height: 1080px;
    }
`
class AlexaVideoPreview extends ScreenPreviewComponent {
    render() {
        return (
            <AlexaRectangleWrapper className={screenStyle}>
                {this.state.videoUrl ?
                    <video controls>
                        <source src={this.state.videoUrl} type="video/mp4" />
                        Your browser does not support videos.
                    </video>
                : null}
            </AlexaRectangleWrapper>
        )
    }
}

export default AlexaVideoPreview;